import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/update-duck";

const { Types, Creators } = createActions(
  {
    request: ["id", "putData", "onSuccess", "onFailure"],
    success: [],
    failure: ["error"],
    reset: [],
  },
  { prefix: "SCHEDULING_EDIT_" }
);

export interface SchedulingEditState extends IState {}

const INITIAL_STATE: SchedulingEditState = {
  loading: false,
  error: null,
};

const request = (state: SchedulingEditState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: SchedulingEditState, action: ISuccessAction) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (state: SchedulingEditState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const schedulingEdit = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const SchedulingEditTypes = Types;
export const SchedulingEditActions = Creators;
